// src/components/dictionary/AddToUserDictionaryModal.jsx
import { useState } from 'react';

export default function AddToUserDictionaryModal({ initialSource, onClose }) {
  const [form, setForm] = useState({
    source: initialSource || '',
    targets: '',
    type: '',
    category: '',
    ner: '',
    mwe: '',
  });

  const handleTypeChange = (type) => {
    setForm((prev) => ({
      ...prev,
      type,
      category: '',
      ner: '',
      mwe: '',
    }));
  };

  const handleSubmit = () => {
    if (!form.source.trim() || !form.targets.trim() || !form.type) {
      alert('Please fill source, target(s) and type');
      return;
    }

    console.log('New dictionary entry:', form);
    // TODO: send to backend

    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
        <div className="bg-blue-600 text-white px-6 py-4 rounded-t-2xl flex justify-between items-center">
          <h2 className="text-xl font-semibold">Add to User Dictionary</h2>
          <button
            onClick={onClose}
            className="text-3xl leading-none hover:text-gray-200"
          >
            ×
          </button>
        </div>

        <div className="p-6 space-y-5">
          <input
            placeholder="Source word"
            value={form.source}
            onChange={(e) => setForm({ ...form, source: e.target.value })}
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />

          <input
            placeholder="Target translation(s) – use comma for multiple"
            value={form.targets}
            onChange={(e) => setForm({ ...form, targets: e.target.value })}
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />

          <select
            value={form.type}
            onChange={(e) => handleTypeChange(e.target.value)}
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="" disabled>Choose type</option>
            <option value="lexical">Lexical</option>
            <option value="ner">NER</option>
            <option value="mwe">MWE</option>
            <option value="term">Term</option>
          </select>

          {form.type === 'lexical' && (
            <select
              value={form.category}
              onChange={(e) => setForm({ ...form, category: e.target.value })}
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="" disabled>Part of speech</option>
              <option value="noun">Noun</option>
              <option value="adj">Adjective</option>
              <option value="pronoun">Pronoun</option>
              <option value="verb">Verb</option>
              <option value="adverb">Adverb</option>
              <option value="fcat">Functional category</option>
            </select>
          )}

          {form.type === 'ner' && (
            <select
              value={form.ner}
              onChange={(e) => setForm({ ...form, ner: e.target.value })}
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="" disabled>NER category</option>
              <option value="person">Person</option>
              <option value="location">Location</option>
              <option value="organization">Organization</option>
            </select>
          )}

          {form.type === 'mwe' && (
            <select
              value={form.mwe}
              onChange={(e) => setForm({ ...form, mwe: e.target.value })}
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="" disabled>MWE category</option>
              <option value="reduplication">Reduplication</option>
              <option value="compound">Compound</option>
              <option value="complexpredicate">Complex Predicate</option>
              <option value="idioms">Idioms</option>
            </select>
          )}

          <button
            onClick={handleSubmit}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 rounded-lg transition-colors mt-4"
          >
            Submit Entry
          </button>
        </div>
      </div>
    </div>
  );
}